"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;

var react_1 = __importDefault(require("react"));

var form_base_1 = require("./form-base");

var Dropdown = function Dropdown(_a) {
  var id = _a.id,
      name = _a.name,
      legend = _a.legend,
      label = _a.label,
      theme = _a.theme,
      options = _a.options,
      error = _a.error,
      _b = _a.defaultOption,
      defaultOption = _b === void 0 ? true : _b,
      onSelectionChanged = _a.onSelectionChanged,
      defaultValue = _a.defaultValue;
  var style = "block appearance-none w-full " + (theme ? theme.form.backgroundColor : "bg-white") + " border " + (theme ? theme.form.borderColor : "border-gray-400") + " hover:" + (theme ? theme.form.borderHoverColor : "border-gray-500") + " px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline";
  var optionStyle = (theme ? theme.form.backgroundColor : "bg-white") + " " + (theme ? theme.form.textColor : "text-gray-800");
  return react_1["default"].createElement(form_base_1.FormBase, {
    label: label,
    htmlFor: id,
    legend: legend,
    theme: theme,
    error: error
  }, react_1["default"].createElement("div", {
    className: "mt-1 inline-block relative"
  }, react_1["default"].createElement("select", {
    id: id,
    name: name,
    onChange: function onChange(_a) {
      var value = _a.target.value;
      return onSelectionChanged(value);
    },
    className: style,
    defaultValue: defaultValue
  }, defaultOption && react_1["default"].createElement("option", {
    className: optionStyle
  }, "Please select"), options.map(function (item, index) {
    return react_1["default"].createElement("option", {
      key: index,
      value: item.value
    }, item.label);
  })), react_1["default"].createElement("div", {
    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
  }, react_1["default"].createElement("svg", {
    className: "fill-current h-4 w-4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, react_1["default"].createElement("path", {
    d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
  })))));
};

exports.Dropdown = Dropdown;